import { observable, action } from "mobx"
class QueryDataStore {
  @observable queryData = new Map()
  @action setQueryData = (key, val) => {
    this.queryData.set(key, val)
  }
}
export default new QueryDataStore()
